// @flow

import React from 'react';

type Props = {
  iconBefore?: string,
  iconAfter?: string,
  text: string,
  type?: string,
  classes?: string,
  handleClick: Function,
  href?: string,
  id?: ?number | ?string
};

const BtnExtended = ({ iconBefore, iconAfter, text, type, classes, handleClick, href, id }: Props) => (
  href
    ? <a
      className={`btn btn_extended${type ? ` btn_${type}` : ''}${classes ? ` ${classes}` : ''}`}
      id={id}
      href={href}
    >
      {iconBefore ? <i className={`icon-${iconBefore}`}/> : ''}
      {text}
      {iconAfter ? <i className={`icon-${iconAfter}`}/> : ''}
    </a>
    : <button
      type="button"
      className={`btn btn_extended${type ? ` btn_${type}` : ''}${classes ? ` ${classes}` : ''}`}
      onClick={handleClick}
      id={id}
    >
      {iconBefore ? <i className={`icon-${iconBefore}`}/> : ''}
      {text}
      {iconAfter ? <i className={`icon-${iconAfter}`}/> : ''}
    </button>
);

BtnExtended.defaultProps = {
  iconBefore: '',
  iconAfter: '',
  type: '',
  href: '',
  id: '',
  classes: ''
};

export default BtnExtended;
